import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function SocialMediaSection() {
  return <section id="redes-sociales" className="py-24 bg-[#0a0a1a] relative overflow-hidden border-t border-white/5" data-id="element-399">
      {/* Background Glows */}
      <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-purple-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-400" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-blue-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-401" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-402">
        {/* Sub-section 1: Hero intro */}
        <div className="text-center mb-24" data-id="element-403">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-medium mb-6" data-id="element-404">
            <Sparkles className="w-4 h-4" data-id="element-405" />
            Redes Sociales
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-bold font-orbitron mb-6 leading-tight" data-id="element-406">
            Estrategia + <br className="md:hidden" data-id="element-407" />
            <span className="text-gradient-cosmic" data-id="element-408">Contenido +</span>{' '}
            <br className="md:hidden" data-id="element-409" />
            Posicionamiento
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-410">
            No se trata de publicar… se trata de{' '}
            <strong className="text-white" data-id="element-411">atraer clientes reales</strong>. En
            Estrategias Digitales AZ diseñamos un sistema completo de
            crecimiento digital para que tu restaurante sea el que la gente
            recuerde, busque y recomiende.
          </motion.p>
        </div>

        {/* Sub-section 2: Sistema de Crecimiento */}
        <div className="mb-32" data-id="element-412">
          <div className="mb-12" data-id="element-413">
            <motion.h3 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold font-orbitron mb-4 text-purple-400" data-id="element-414">
              No Manejamos Redes... <br className="hidden md:block" data-id="element-415" />
              <span className="text-cyan-400" data-id="element-416">
                Creamos un Sistema de Crecimiento
              </span>
            </motion.h3>
            <motion.p initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gray-400 max-w-2xl text-lg" data-id="element-417">
              Detrás de cada publicación hay un proceso estratégico
              cuidadosamente diseñado para generar resultados reales en tu
              restaurante.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-418">
            {[{
            icon: '🧠',
            title: 'Análisis Previo',
            desc: 'Estudiamos tu restaurante, analizamos la competencia local e identificamos las oportunidades de contenido más relevantes para tu mercado.'
          }, {
            icon: '📊',
            title: 'Decisiones Basadas en Datos',
            desc: 'Detectamos los mejores días y horarios para publicar, y el tipo de contenido que más conecta con tu audiencia. No publicamos al azar.'
          }, {
            icon: '🔍',
            title: 'Tendencias y Posicionamiento',
            desc: 'Identificamos contenido en tendencia, lo adaptamos a tu restaurante y trabajamos para posicionarte como la referencia en tu categoría.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15
          }} className="bg-[#050510] border border-white/10 rounded-2xl p-8 hover:border-purple-500/30 transition-colors" data-id="element-419">
                <div className="text-4xl mb-4" data-id="element-420">{item.icon}</div>
                <h4 className="text-xl font-bold text-white mb-3 font-orbitron" data-id="element-421">
                  {item.title}
                </h4>
                <p className="text-gray-400 leading-relaxed" data-id="element-422">{item.desc}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="mt-8 bg-blue-900/20 border border-blue-500/30 rounded-xl p-6 flex items-start gap-4" data-id="element-423">
            <div className="mt-1 flex-shrink-0" data-id="element-424">
              <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" data-id="element-425" />
            </div>
            <p className="text-blue-200 font-medium" data-id="element-426">
              Nuestro objetivo es que tu restaurante sea el primero que la gente
              recuerde y recomiende.
            </p>
          </motion.div>
        </div>

        {/* Sub-section 3: ¿Cómo Creamos el Contenido? */}
        <div className="mb-32" data-id="element-427">
          <div className="text-center mb-16" data-id="element-428">
            <motion.h3 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-bold font-orbitron mb-6 text-purple-400" data-id="element-429">
              ¿Cómo Creamos el Contenido?
            </motion.h3>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gray-400 max-w-3xl mx-auto text-lg" data-id="element-430">
              Cada pieza de contenido que producimos sigue un proceso
              profesional diseñado para captar atención, generar confianza y
              convertir seguidores en clientes.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-431">
            {[{
            icon: '🎬',
            title: 'Producción Profesional',
            desc: 'Grabación en tu restaurante con dirección de contenido: te decimos qué decir y cómo decirlo. Adaptamos todo a formatos actuales como Reels y contenido dinámico.'
          }, {
            icon: '🎨',
            title: 'Edición Optimizada',
            desc: 'Edición profesional de video e imagen con formatos diseñados para captar atención en los primeros segundos. Estética alineada a tu marca y branding.'
          }, {
            icon: '✍️',
            title: 'Guión y Copywriting',
            desc: 'Creamos guiones estratégicos con estructura de Hook (enganche), Desarrollo y Llamado a la Acción. Cada publicación tiene un objetivo claro.'
          }, {
            icon: '⚙️',
            title: 'Estrategia Funnel',
            desc: 'Usamos formatos UGC (contenido natural tipo cliente) y DTC (contenido directo a conversión). Estructura: atraer → generar interés → convertir.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-[#050510]/50 border border-white/5 rounded-2xl p-6 hover:bg-[#050510] hover:border-white/10 transition-all" data-id="element-432">
                <div className="text-3xl mb-4" data-id="element-433">{item.icon}</div>
                <h4 className="text-lg font-bold text-white mb-3 font-orbitron" data-id="element-434">
                  {item.title}
                </h4>
                <p className="text-sm text-gray-400 leading-relaxed" data-id="element-435">
                  {item.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Sub-section 4: Medimos, Analizamos y Optimizamos */}
        <div data-id="element-436">
          <div className="mb-12" data-id="element-437">
            <motion.h3 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold font-orbitron mb-4 text-cyan-400" data-id="element-438">
              Medimos, Analizamos y Optimizamos
            </motion.h3>
            <motion.p initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gray-400 max-w-3xl text-lg" data-id="element-439">
              El crecimiento sostenido no es suerte: es el resultado de{' '}
              <strong className="text-white" data-id="element-440">
                análisis constante + ejecución precisa
              </strong>
              . Cada semana revisamos el rendimiento y ajustamos la estrategia
              para maximizar resultados.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-441">
            {/* Left Card */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-[#8b9b7a] rounded-3xl p-8 text-[#1a1f16]" data-id="element-442">
              <div className="mb-8" data-id="element-443">
                <h4 className="text-2xl font-bold mb-4 flex items-center gap-3" data-id="element-444">
                  📊 Seguimiento Semanal
                </h4>
                <p className="text-[#2a3224] text-lg" data-id="element-445">
                  Evaluamos el rendimiento de cada publicación, identificamos
                  qué contenido funciona mejor y qué tipo de cliente responde
                  más a tu mensaje.
                </p>
              </div>
              <div data-id="element-446">
                <h4 className="text-2xl font-bold mb-4 flex items-center gap-3" data-id="element-447">
                  🔍 Optimización Constante
                </h4>
                <p className="text-[#2a3224] text-lg" data-id="element-448">
                  Ajustamos la estrategia cada semana: repetimos lo que funciona
                  y eliminamos lo que no genera resultados.
                </p>
              </div>
            </motion.div>

            {/* Right Side */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex flex-col justify-center" data-id="element-449">
              <div className="mb-8" data-id="element-450">
                <h4 className="text-2xl font-bold text-cyan-400 mb-4 flex items-center gap-3 font-orbitron" data-id="element-451">
                  🧠 Inteligencia de Contenido
                </h4>
                <p className="text-gray-300 text-lg" data-id="element-452">
                  Detectamos patrones de viralidad, aprovechamos tendencias en
                  tiempo real y adaptamos el contenido al comportamiento real de
                  tu público.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-453">
                <div className="bg-white/5 border border-white/10 rounded-xl p-5" data-id="element-454">
                  <h5 className="text-white font-bold mb-2" data-id="element-455">Analizar</h5>
                  <p className="text-sm text-gray-400" data-id="element-456">
                    Revisar métricas semanales
                  </p>
                </div>
                <div className="bg-white/5 border border-white/10 rounded-xl p-5" data-id="element-457">
                  <h5 className="text-white font-bold mb-2" data-id="element-458">Ajustar</h5>
                  <p className="text-sm text-gray-400" data-id="element-459">Optimizar estrategia</p>
                </div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-xl p-5" data-id="element-460">
                <h5 className="text-white font-bold mb-2" data-id="element-461">Crecer</h5>
                <p className="text-sm text-gray-400" data-id="element-462">Repetir lo que funciona</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}